/**
 * Copyright (c) NCR Terafina
 **/
import React from 'react';
import { Container } from 'react-bootstrap';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.scss';
import GuardedRoute from './GuardedRoute';
import Login from './Login';
import { AnalyticsService } from './AnalyticsService';
import Home from './Home';
/**
 * The app routing component
 *
 */
export default function App() {
  AnalyticsService.initialize();
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div>
        <Container className="px-0" fluid>
          <Switch>
            <Route path="/login">
              <Login />
            </Route>
            <GuardedRoute path="/">
              <Home />
            </GuardedRoute>
          </Switch>
        </Container>
      </div>
    </Router>
  );
}
